import {
    IClientSourceOfHireStats,
    SOURCE_OF_HIRE_TOP3_CONFIGS,
} from '../../../../common';
import Top3Card from './Top3Card';
import { StyledTop3Row } from './Top3Section.styles';

interface ITop3SectionProps {
    stats: IClientSourceOfHireStats;
}

const Top3Section = ({ stats }: ITop3SectionProps) => {
    return (
        <StyledTop3Row direction="row">
            {SOURCE_OF_HIRE_TOP3_CONFIGS.map((config) => (
                <Top3Card
                    key={config.statsKey}
                    titleKey={config.titleKey}
                    isPercent={config.isPercent}
                    entries={stats[config.statsKey]}
                />
            ))}
        </StyledTop3Row>
    );
};

export default Top3Section;
